"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AvatarStyled = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _styledSystem = require("styled-system");
var _templateObject;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var AvatarStyled = _styledComponents["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\t", "\n\t", "\n\tbackground: url(", ");\n\t", "\n\tbackground-size: cover;\n\tbackground-position: center;\n\tbackground-repeat: no-repeat;\n\tcursor: ", ";\n\tbox-shadow: ", ";\n"])), (0, _styledSystem.variant)({
  scale: 'avatarSizes',
  prop: 'size'
}), (0, _styledSystem.variant)({
  scale: 'avatarShapes',
  prop: 'shape'
}), function (props) {
  return props.img;
}, (0, _styledSystem.variant)({
  scale: 'backgrounds',
  prop: 'background'
}), function (props) {
  return props.onClick ? 'pointer' : '';
}, function (props) {
  if (!props.withBorder) return '';
  return "0 0 0 2px #FFF , 0 0 0 4px ".concat(props.theme.colors[props.borderColor]);
});
exports.AvatarStyled = AvatarStyled;